export * from './orders-aggregator.interface';
export * from './orders-aggregator.service';
export * from './orders-aggregator.mock';
export const ORDERS_AGGREGATOR_SERVICE = Symbol('OrdersAggregatorService');
